import { clampedAlpha } from "./lerp-utils.js";
import * as THREE from "three";
//#region ../src/visualization/alignment-lerper.ts
/**
* Alignment Lerper Module
*
* Smoothly interpolates arWorldGroup.matrix toward a target alignment
* matrix each frame, eliminating visual jumps when the alignment solver
* produces a new alignment (~1 Hz).
*
* Pattern: decompose → lerp position / slerp quaternion → compose.
* Same lerpRate convention as camera-follower.ts (default 8 → ~90%
* convergence in ~0.3 s at 60 fps).
*
* The first target is applied instantly (no animation from identity).
*
* @see docs/2026-03-21-user-feedback.md Issue 4
*/
const _currentPos = new THREE.Vector3();
const _currentQuat = new THREE.Quaternion();
const _currentScale = new THREE.Vector3();
new THREE.Vector3();
new THREE.Quaternion();
new THREE.Vector3();
/**
* Create an AlignmentLerper that drives arWorldGroup.matrix smoothly.
*
* @param arWorldGroup The group whose matrix is interpolated.
* @param lerpRate     Lerp speed multiplier (default 8).
*/
function createAlignmentLerper(arWorldGroup, lerpRate = 8) {
	let hasTarget = false;
	let isFirstTarget = true;
	const storedTargetPos = new THREE.Vector3();
	const storedTargetQuat = new THREE.Quaternion();
	const storedTargetScale = new THREE.Vector3(1, 1, 1);
	const _matrix = new THREE.Matrix4();
	return {
		setTarget(matrix) {
			_matrix.fromArray(matrix);
			_matrix.decompose(storedTargetPos, storedTargetQuat, storedTargetScale);
			hasTarget = true;
		},
		update(dt) {
			if (!hasTarget) return;
			if (isFirstTarget) {
				_matrix.compose(storedTargetPos, storedTargetQuat, storedTargetScale);
				arWorldGroup.matrix.copy(_matrix);
				arWorldGroup.matrixAutoUpdate = false;
				arWorldGroup.updateMatrixWorld(true);
				isFirstTarget = false;
				return;
			}
			arWorldGroup.matrix.decompose(_currentPos, _currentQuat, _currentScale);
			const alpha = clampedAlpha(lerpRate, dt);
			_currentPos.lerp(storedTargetPos, alpha);
			_currentQuat.slerp(storedTargetQuat, alpha);
			_currentScale.lerp(storedTargetScale, alpha);
			_matrix.compose(_currentPos, _currentQuat, _currentScale);
			arWorldGroup.matrix.copy(_matrix);
			arWorldGroup.matrixAutoUpdate = false;
			arWorldGroup.updateMatrixWorld(true);
		},
		dispose() {}
	};
}
//#endregion
export { createAlignmentLerper };
